import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription, DrawerBody, Button, Spinner, EmptyState } from '../ui';

/**
 * A side sheet listing the items behind a number. Generic: Heartbeat passes
 * replies; the scan retrofit can pass posts. Sorting and paging are the
 * caller's (they are query params), this only renders.
 */
export function EvidenceDrawer({ open, onOpenChange, title, description, filters, items = [], renderItem, sortOptions = [], sort, onSortChange, loading = false, hasMore = false, onLoadMore, emptyTitle = 'Nothing here yet', emptyDescription }) {
	return (
		<Drawer open={open} onOpenChange={onOpenChange}>
			<DrawerContent>
				<DrawerHeader>
					<DrawerTitle>{title}</DrawerTitle>
					{description && <DrawerDescription>{description}</DrawerDescription>}
					{filters && <div className="mt-3">{filters}</div>}
					{sortOptions.length > 0 && (
						<div className="mt-3 flex items-center gap-2 text-xs text-muted-foreground">
							<span>Sort</span>
							{sortOptions.map((o) => (
								<button key={o.value} type="button" onClick={() => onSortChange?.(o.value)}
									className={sort === o.value ? 'rounded-full bg-brand-600 px-2.5 py-1 font-medium text-white' : 'rounded-full bg-muted px-2.5 py-1 font-medium text-foreground hover:bg-accent'}>
									{o.label}
								</button>
							))}
						</div>
					)}
				</DrawerHeader>
				<DrawerBody>
					{loading && items.length === 0 ? (
						<div className="flex justify-center py-10"><Spinner /></div>
					) : items.length === 0 ? (
						<EmptyState compact title={emptyTitle} description={emptyDescription} />
					) : (
						<ul className="divide-y divide-border">{items.map((it, i) => <li key={it._id || it.id || i} className="py-3">{renderItem(it)}</li>)}</ul>
					)}
					{hasMore && (
						<div className="pt-4 text-center">
							<Button variant="outline" size="sm" onClick={onLoadMore} disabled={loading}>{loading ? <Spinner size="sm" /> : 'Show more'}</Button>
						</div>
					)}
				</DrawerBody>
			</DrawerContent>
		</Drawer>
	);
}
export default EvidenceDrawer;
